import React from 'react';
import BookingForm from '../components/BookingForm';

const Booking = () => {
  return (
    <div>
      
      <BookingForm />
    </div>
  );
};

export default Booking;
